'use client'

import { useEffect, useState } from 'react'

type BreakpointState = {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
}

export function useBreakpoint(): BreakpointState {
  const [state, setState] = useState<BreakpointState>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  })

  useEffect(() => {
    const queries = {
      mobile: window.matchMedia(`(max-width: ${768 - 1}px)`),
      tablet: window.matchMedia(`(min-width: ${768}px) and (max-width: ${1024 - 1}px)`),
      desktop: window.matchMedia(`(min-width: ${1024}px)`),
    }

    const update = () =>
      setState({
        isMobile: queries.mobile.matches,
        isTablet: queries.tablet.matches,
        isDesktop: queries.desktop.matches,
      })

    update()
    Object.values(queries).forEach((q) => q.addEventListener('change', update))

    return () => Object.values(queries).forEach((q) => q.removeEventListener('change', update))
  }, [])

  return state
}
